<div #scrollTarget></div>

<div class="container-fluid mt-4">
  

  <div class="row mb-3 align-items-end">
    <h4 class="col-md-4">
      <i class="fi fi-rr-list"></i><span class="mx-1">მარჯვენა ბლოკი</span>
    </h4>

    <div class="col-md-2 ms-auto">
      <button
        class="btn btn-primary w-100"
        (click)="openCreate()"
        *ngIf="admin.hasPermission('banner_create') || admin.user.role === 'admin'">
        დამატება
      </button>
    </div>
  </div>

  <app-spinner [loading]="loading" text="იტვირთება..."></app-spinner>

  <div class="alert alert-info" *ngIf="!loading && !items.length">
    ჩანაწერები ვერ მოიძებნა
  </div>

  <div class="table-responsive" *ngIf="!loading && items.length">
    <table class="table table-bordered table-hover align-middle">
      <thead>
        <tr>
          <th style="width:55px;">#</th>
          <th style="width:60px;">⇅</th>
          <th>სათაური</th>
          <th>ბმული</th>
          <th style="width:160px;" class="text-end">ქმედებები</th>
        </tr>
      </thead>

      <!-- IMPORTANT: cdkDropList tbody-ზე -->
      <tbody
        cdkDropList
        [cdkDropListData]="items"
        (cdkDropListDropped)="drop($event)">

        <tr *ngFor="let item of items; let i = index" cdkDrag>
          <td>{{ i + 1 }}</td>

          <!-- Drag handle -->
          <td class="text-center" style="cursor: grab;">
            <span cdkDragHandle title="გადმოათრიე სორტირებისთვის">☰</span>
          </td>

          <td>
            <div class="fw-semibold">{{ item.title }}</div>
            <small class="text-muted">ID: {{ item.id }}</small>
          </td>

          <td class="text-truncate" style="max-width: 520px">
            <a [href]="item.url" target="_blank" rel="noopener">{{ item.url }}</a>
            <div class="text-muted small"> {{ item.target == 1 ? 'ახალ ფანჯარაში' : 'იმავე ფანჯარაში' }}</div>
          </td>

          <td class="text-end">

            <button
              class="btn btn-sm border rounded me-2"
              (click)="toggleVisible(item)"
              [disabled]="togglingId === item.id">

              <span
                *ngIf="togglingId === item.id"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true">
              </span>

              <ng-container *ngIf="togglingId !== item.id">
                <i class="fi fi-rs-eye text-success" *ngIf="item.visible == 1"></i>
                <i class="fi fi-rr-eye-crossed text-danger" *ngIf="item.visible == 0"></i>
              </ng-container>

            </button>



            <button
              class="btn btn-sm border rounded me-2"
              (click)="openEdit(item.id)"
              *ngIf="admin.hasPermission('banner_edit') || admin.user.role === 'admin'">
              <i class="fi fi-rr-pencil"></i>
            </button>

            <button
              class="btn btn-sm border rounded"
              (click)="delete(item)"
              [disabled]="isDeleting(item.id)"
              title="წაშლა"
              *ngIf="admin.hasPermission('banner_delete') || admin.user.role === 'admin'">
              <span *ngIf="isDeleting(item.id)" class="spinner-border spinner-border-sm"></span>
              <i *ngIf="!isDeleting(item.id)" class="fi fi-rr-trash text-danger"></i>
            </button>
          </td>
        </tr>

      </tbody>
    </table>
  </div>
</div>